export default {
  // customer: (state) => {
  //   return state.custmer
  // },
};
